const ThresholdsIcon = ({ darkMode }) => {
  return (
    <svg
      viewBox="0 0 384 384"
      className={`${darkMode ? 'text-white' : 'text-[#27292C]'} mr-4 h-6`}
    >
      <g>
        <path
          fill="currentColor"
          d="M8.2 381 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 8.5 -6.5 15 -15 15 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M56.2 381 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 8.5 -6.5 15 -15 15 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M104.2 381 c-9.6 -5.9 -9.6 -20.1 0 -26 2 -1.2 5.1 -2 7.8 -2 15.2 0 20.8 20.1 7.8 28 -2 1.2 -5.1 2 -7.8 2 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M152.2 381 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -2 1.2 -5.1 2 -7.8 2 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M200.2 381 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -2 1.2 -5.1 2 -7.8 2 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M248.2 381 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 8.5 -6.5 15 -15 15 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M296.2 381 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 8.5 -6.5 15 -15 15 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M344.2 381 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 8.5 -6.5 15 -15 15 -2.7 0 -5.8 -0.8 -7.8 -2z"
        />
        <path
          fill="currentColor"
          d="M153.7 318.9 c-12.9 -1.9 -24.3 -11.7 -32.5 -27.7 -9.1 -17.7 -13.8 -33.1 -24.7 -80.9 l-0.5 -2.3 -48 0 -48 0 0 -16 0 -16 44.5 0 44.5 0 -0.6 -2.7 c-4.1 -18.8 -11.4 -42.4 -15.6 -50.8 -4.1 -8.1 -6.5 -10.5 -10.8 -10.5 -2.1 0 -5 0.5 -6.4 1.2 -2.6 1.1 -7.6 9.7 -7.6 13 0 2.1 -1.7 2.2 -19.7 1.1 l-11.3 -0.6 0 -2.7 c0 -3.7 2.7 -12.6 5.7 -18.4 9.6 -18.9 34.2 -29.5 52.7 -22.6 7.4 2.8 16.7 11.7 22.3 21.5 9.2 16 14.5 33.4 25.4 83.5 11.7 53.9 17.2 73.8 23.5 86 4 7.6 9 14 10.9 14 1.4 0 5.5 -6.5 13.1 -20.8 8.7 -16.3 19.1 -24.1 36 -26.6 10.4 -1.5 13 -3 17.8 -9.5 3.4 -4.7 11.6 -20.2 11.6 -22.1 0 -0.7 -14.2 -1 -42.5 -1 l-42.4 0 -1 -3.7 c-0.5 -2.1 -2.2 -8.5 -3.6 -14.3 -1.4 -5.8 -2.8 -11.3 -3.1 -12.2 -0.5 -1.7 2.4 -1.8 51.3 -1.8 l51.8 0 6.4 -25.7 c11.2 -45.6 18.1 -63 29.3 -74.5 7.3 -7.6 14.4 -10.9 23.1 -10.9 7.7 0 10.7 0.7 17.2 3.9 10.8 5.3 19.1 14.7 24.3 27.4 5.4 13.3 6.3 12 -9.6 15.1 -7.6 1.5 -14.3 2.7 -14.9 2.7 -0.6 0 -2.5 -2.9 -4.1 -6.5 -3.7 -7.8 -7.2 -11.5 -10.8 -11.5 -3.1 0 -4.3 1.4 -8.3 9 -4.4 8.4 -8.3 21.4 -17.5 58 -12.8 50.9 -19.4 68.6 -31.6 84.8 -10.4 13.9 -22.5 21.3 -37.4 23.2 -6.4 0.8 -7.4 1.2 -10.1 4.3 -1.7 2 -6 9.1 -9.5 15.8 -11.6 22 -23.2 30.2 -39.3 27.8z"
        />
        <path
          fill="currentColor"
          d="M289 207.8 c0 -0.2 1.6 -6.5 3.5 -14.1 1.9 -7.7 3.5 -14.7 3.5 -15.8 0 -1.8 1.4 -1.9 44 -1.9 l44 0 0 16 0 16 -47.5 0 c-26.1 0 -47.5 -0.1 -47.5 -0.2z"
        />
        <path
          fill="currentColor"
          d="M8.2 29 c-13 -7.9 -7.4 -28 7.8 -28 8.5 0 15 6.5 15 15 0 11.6 -12.9 19 -22.8 13z"
        />
        <path
          fill="currentColor"
          d="M56.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M104.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M152.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M200.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M248.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M296.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
        <path
          fill="currentColor"
          d="M344.2 29 c-13 -7.9 -7.4 -28 7.8 -28 15.2 0 20.8 20.1 7.8 28 -4.3 2.6 -11.3 2.6 -15.6 0z"
        />
      </g>
    </svg>
  )
}

export default ThresholdsIcon
